import React, { useState } from 'react'
import Head from 'next/head'
import { blocksToHtml, blocksToPlainText } from '../../helpers/strapiBlocks'
import { Header2, LinkButton } from '../../styles/Components'
import { FAQWrapper } from './styles'

const DEFAULT_SEE_ALL_URL = '/faq'

const FAQ = ({ faqs, seeAllUrl = DEFAULT_SEE_ALL_URL }) => {
  const [openId, setOpenId] = useState(null)

  if (!Array.isArray(faqs) || faqs.length === 0) {
    return null
  }

  const handleToggle = (id) => {
    setOpenId((current) => (current === id ? null : id))
  }

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs
      .filter((faq) => faq.question)
      .map((faq) => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: blocksToPlainText(faq.answer),
        },
      })),
  }

  return (
    <>
      <Head>
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      </Head>
      <FAQWrapper>
        <Header2 align='center'>FAQs</Header2>
        <div className='faq-list'>
          {faqs.map((faq) => {
            if (!faq.question) {
              return null
            }
            const isOpen = openId === faq.id
            const answerId = `faq-answer-${faq.id}`
            return (
              <div
                key={faq.id}
                className={`faq-item${isOpen ? ' open' : ''}`}
              >
                <button
                  type='button'
                  className='faq-item-question'
                  aria-expanded={isOpen}
                  aria-controls={answerId}
                  onClick={() => handleToggle(faq.id)}
                >
                  <span>{faq.question}</span>
                </button>
                <div
                  id={answerId}
                  className='faq-item-answer'
                  dangerouslySetInnerHTML={{ __html: blocksToHtml(faq.answer) }}
                />
              </div>
            )
          })}
        </div>
        <LinkButton
          href={seeAllUrl}
          {...(/^https?:\/\//.test(seeAllUrl || '') ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
          outline
          large
          color='#000'
          className='faq-see-all'
        >
          See All FAQs
        </LinkButton>
      </FAQWrapper>
    </>
  )
}

export default FAQ
